module.exports = {"oss":{"servicename":"oss","background":"#5ca1bf","chatbox":"#b5d7f9","header":{"background":"#034d9a","font-color":"#ffffff"},"tabheader_chat":{"background":"#f3f1f1","font-color":"#737373"},"authen":"Ad9bab3e81e925ba69d1d202f4b493695b66af4d6e0284a5fa3636573fe8230622d07979e25904337b9671311822d1521","bot_id":"B650d900fa3155937b46218b6f850d6e0","image_logo":"/static/lotus/logo2.jpeg","styleLogo":"max-width: 70vw;max-height: 10vh;","image_powerby":"/static/inet/logo.png"}}


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme.json
// module id = 6ZH5
// module chunks = 1